import { useTranslation } from 'react-i18next';
import { Chip } from '@mui/material';

function SendoutContactStatusChip({ status }) {
    const { t } = useTranslation();

    switch (status) {
        case null:
        case undefined:
        case '':
            return null;
        case 'error':
            return <Chip label={t('Error')} size="small" color="error" />;
        case 'done':
            return <Chip label={t('Done')} size="small" color="success" />
        case 'unsubscribed':
            return <Chip label={t('Unsubscribed')} size="small" color="error" />
        default:
            return <Chip label={status} size="small" />
    }
}

export default SendoutContactStatusChip;